'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' });

var DeviceHub = function DeviceHub(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DeviceHub = (0, _pure2.default)(DeviceHub);
DeviceHub.muiName = 'SvgIcon';

exports.default = DeviceHub;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DeviceHub.js
// module id = 2311
// module chunks = 0